import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import VendorInvoiceComponent from "./VendorInvoiceComponent";
import Uri from "../../Network/Uri";
import {
  ADD_VENDOR_INVOICE,
  GET_VENDOR_INVOICES,
  UPDATE_VENDOR_INVOICE,
  DELETE_VENDOR_INVOICE,
  GET_VENDORS,
} from "../../Network/ApiPaths";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";

let storeFresh;
let clientHost;

class VendorInvoiceContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }
    this.state = {
      invoices: [],
      vendors: [],
      selectedVendor: "",
      invoiceDate: "",
      invoiceAmount: "",
      status: "NOTPAID",
      invoiceFile: null,
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
      filterStatus: "",
    };
  }

  componentDidMount() {
    this.getInvoices();
    this.getVendors();
  }
  onInvoiceFileChange = (e) => this.setState({ invoiceFile: e.target.files[0] });
  onVendorChange = (e) => this.setState({ selectedVendor: e.target.value });
  onInvoiceDateChange = (e) => this.setState({ invoiceDate: e.target.value });
  onInvoiceAmountChange = (e) =>
    this.setState({ invoiceAmount: e.target.value });
  onStatusChange = (e) => this.setState({ status: e.target.value });

  onFilterVendorChange = (e) =>
    this.setState({ filterVendorId: e.target.value });
  onFilterFromDateChange = (e) =>
    this.setState({ filterFromDate: e.target.value });
  onFilterToDateChange = (e) =>
    this.setState({ filterToDate: e.target.value });
  onFilterStatusChange = (e) =>
    this.setState({ filterStatus: e.target.value });

  onResetFilters = () => {
    this.setState({
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
      filterStatus: "",
    });
  };

  //  Export function
  onExport = (filteredInvoices) => {
    const data = filteredInvoices.map((inv, index) => {
      const vendor = this.state.vendors.find((v) => v.id === inv.vendor_id);

      return {
        "S.No": index + 1,
        "Vendor Name": vendor ? vendor.vendor_name : "",
        "Invoice Date": inv.invoice_date,
        "Invoice Amount": inv.invoice_amount,
        "Status": inv.status,
        "Balance Amount": inv.balance_amount,  
        "Uploaded Date": inv.uploaded_date,
        "Invoice File URL": inv.invoice_file || "",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "VendorInvoices");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "VendorInvoices.xlsx");
  };

  addInvoice = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("vendor_id", this.state.selectedVendor);
    formData.append("invoice_date", this.state.invoiceDate);
    formData.append("invoice_amount", this.state.invoiceAmount);
    formData.append("balance_amount", this.state.invoiceAmount);
    formData.append("status", this.state.status);
    formData.append("uploaded_date", new Date().toISOString().split("T")[0]);
    formData.append("store_id", storeFresh.storeId);

    if (this.state.invoiceFile) {
      formData.append("invoice_file", this.state.invoiceFile);
    }

    postClientDataResponse(
      clientHost + ADD_VENDOR_INVOICE,
      storeFresh.key,
      formData,
      () => this.getInvoices(),
      (err) => console.log(err)
    );
  };

  getInvoices = () => {
    var apiPath = new Uri(clientHost + GET_VENDOR_INVOICES).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ invoices: res.result }),
      (err) => console.log(err)
    );
  };

  getVendors = () => {
    var apiPath = new Uri(clientHost + GET_VENDORS).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ vendors: res.result }),
      (err) => console.log(err)
    );
  };

  deleteInvoice = (id) => {
    var apiPath = new Uri(clientHost + DELETE_VENDOR_INVOICE).addQueryParam(
      "id",
      id
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      () => this.getInvoices(),
      (err) => console.log(err)
    );
  };

  updateInvoice = (invoice) => {
    const formData = new FormData();
    formData.append("id", invoice.invoice_id);
    formData.append("vendor_id", invoice.vendor_id);
    formData.append("invoice_date", invoice.invoice_date);
    formData.append("invoice_amount", invoice.invoice_amount);
    formData.append("status", invoice.status);

    postClientDataResponse(
      clientHost + UPDATE_VENDOR_INVOICE,
      storeFresh.key,
      formData,
      () => this.getInvoices(),
      (err) => console.log(err)
    );
  };

  render() {
    return (
      <VendorInvoiceComponent
        invoices={this.state.invoices}
        vendors={this.state.vendors}
        selectedVendor={this.state.selectedVendor}
        status={this.state.status}
        filterVendorId={this.state.filterVendorId}
        filterFromDate={this.state.filterFromDate}
        filterToDate={this.state.filterToDate}
        filterStatus={this.state.filterStatus}
        onVendorChange={this.onVendorChange}
        onInvoiceDateChange={this.onInvoiceDateChange}
        onInvoiceAmountChange={this.onInvoiceAmountChange}
        onStatusChange={this.onStatusChange}
        onInvoiceFileChange={this.onInvoiceFileChange}
        addInvoice={this.addInvoice}
        deleteInvoice={this.deleteInvoice}
        updateInvoice={this.updateInvoice}
        onFilterVendorChange={this.onFilterVendorChange}
        onFilterFromDateChange={this.onFilterFromDateChange}
        onFilterToDateChange={this.onFilterToDateChange}
        onFilterStatusChange={this.onFilterStatusChange}
        onResetFilters={this.onResetFilters}
        onExport={this.onExport}
      />
    );
  }
}

export default VendorInvoiceContainer;
